import { render, staticRenderFns } from "./AllInvoices.vue?vue&type=template&id=2c3e3500&"
import script from "./AllInvoices.vue?vue&type=script&lang=js&"
export * from "./AllInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports